/* EspressoWorks product page helpers (2026-10 restyle).
   1. Tick-to-add extras: live "Your order" total, mirrored into the Add to
      cart button price; one submit posts the machine plus the ticked extras.
   2. Keeps the merchant's Add to cart label after a variant change (the
      theme's ProductForm otherwise rewrites it to the default string).
   Loaded by sections/main-product.liquid only when an ew_addons block exists
   (the label fix lives in theme.js itself). */
(function () {
  'use strict';

  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  function money(cents) {
    var s = fmt.format(cents / 100);
    return s.replace(/\.00$/, '');
  }

  function initAddons(root) {
    var formId = root.dataset.form;
    var form = document.getElementById(formId);
    if (!form) return;
    var boxes = Array.prototype.slice.call(root.querySelectorAll('input[type="checkbox"]'));
    var totalLine = root.querySelector('[data-ewp-total-line]');
    var totalEl = root.querySelector('[data-ewp-total]');
    var savingEl = root.querySelector('[data-ewp-saving]');
    var sectionId = root.dataset.section, productId = root.dataset.product;
    var buyPrice = document.querySelector('#BuyButtonPrice-' + sectionId + '-' + productId + ' product-buy-price');

    function basePrice() {
      // product-buy-price carries the selected variant's price in cents and is kept current by theme.js
      if (buyPrice && buyPrice.dataset.price) return parseInt(buyPrice.dataset.price, 10) || 0;
      return 0;
    }
    function ticked() { return boxes.filter(function (b) { return b.checked; }); }

    function render() {
      var extras = ticked();
      var base = basePrice();
      var add = 0, compare = 0;
      extras.forEach(function (b) {
        add += parseInt(b.dataset.price, 10) || 0;
        compare += parseInt(b.dataset.compare, 10) || 0;
      });
      if (!extras.length) {
        if (totalLine) totalLine.hidden = true;
        if (buyPrice && buyPrice.dataset.ewpBaseText !== undefined) { buyPrice.textContent = buyPrice.dataset.ewpBaseText; delete buyPrice.dataset.ewpBaseText; }
        return;
      }
      var total = base + add;
      if (totalEl) totalEl.textContent = money(total);
      if (savingEl) {
        var saving = compare - add;
        savingEl.hidden = saving <= 0;
        savingEl.textContent = saving > 0 ? 'Save ' + money(saving) + ' on the extras' : '';
      }
      if (totalLine) totalLine.hidden = false;
      if (buyPrice) {
        if (buyPrice.dataset.ewpBaseText === undefined) buyPrice.dataset.ewpBaseText = buyPrice.textContent;
        buyPrice.textContent = money(total);
      }
    }

    boxes.forEach(function (b) { b.addEventListener('change', render); });
    // theme.js re-renders the buy price on variant change (data-price changes, text is rewritten):
    // forget the stored base string and re-apply the extras on the new price.
    var mo = buyPrice ? new MutationObserver(function () {
      if (ticked().length) { delete buyPrice.dataset.ewpBaseText; setTimeout(render, 0); }
    }) : null;
    if (mo) mo.observe(buyPrice, { attributes: true, attributeFilter: ['data-price'] });

    // One Add to cart for the set plus the extras
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var extras = ticked();
      if (!extras.length || !window.fetch) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = document.querySelector('[form="' + formId + '"][name="quantity"], #' + formId + ' [name="quantity"]');
      var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput && qtyInput.value || '1', 10) || 1 }];
      extras.forEach(function (b) { items.push({ id: parseInt(b.dataset.variantId, 10), quantity: 1 }); });
      var buttons = Array.prototype.slice.call(document.querySelectorAll('button[form="' + formId + '"][name="add"], #' + formId + ' button[name="add"]'));
      buttons.forEach(function (btn) { btn.setAttribute('disabled', ''); btn.classList.add('is-loading'); });
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function (data) {
        buttons.forEach(function (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); });
        if (data && data.status && data.status >= 400) throw new Error(data.description || 'Could not add');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (window.upcartOpenCart) { window.upcartOpenCart(); return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      }).catch(function (err) {
        buttons.forEach(function (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); });
        var msg = form.closest('.product-form-wrapper') ? form.closest('.product-form-wrapper').querySelector('.product-form__error-message') : null;
        if (msg) { msg.hidden = false; msg.textContent = err.message; }
      });
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-ewp-addons]:not([data-ewp-ready])').forEach(function (root) {
      root.setAttribute('data-ewp-ready', '1');
      initAddons(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
